import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs';
import { RaygunService } from 'src/app/raygun/raygun.service';
import { SessionStorage } from 'src/app/shared/models/clux/enum';
import { BrowserSessionStorageService } from 'src/app/shared/services/browser-session-storage.service';

import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthDistributorGuard {
  private authenticationService = inject(AuthenticationService);
  private browserSessionStorageService = inject(BrowserSessionStorageService);
  private raygunService = inject(RaygunService);
  private router = inject(Router);

  public canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return from(this.authenticationService.refreshSession()).pipe(
      switchMap((refreshSessionResult) => {
        if (!refreshSessionResult) {
          this.browserSessionStorageService.set(SessionStorage.Url, _state.url);
          return of(this.router.parseUrl('/logout'));
        }
        return of(true);
      }),
      catchError((error: unknown) => {
        this.raygunService.logError('Error in auth-distributor.guard.ts:canActivate()', { error });
        return of(this.router.parseUrl('/logout'));
      })
    );
  }
}
